export default __webpack_public_path__ + "assets/spinner_action_blue.png";